import { ILayer } from '../../../../models';

export type LayerHealthStatus = 'unknown' | 'ok' | 'warning';

export interface ILayerRuntimeStatus {
  status: LayerHealthStatus;
  lastError?: string;
  lastUpdated: number;
  cycle: number;
}

export interface ILayerHealthSnapshot {
  layerStatusByKey: { [key: string]: ILayerRuntimeStatus };
  layerStatusRevision: number;
  layerStatusCycle: number;
}

export type LayerHealthChanged = (snapshot: ILayerHealthSnapshot) => void;

export interface ILayerEventSubscription {
  layer: any;
  onLoad: () => void;
  onTileLoad: () => void;
  onError: (e: any) => void;
}

export const createUnknownLayerStatus = (cycle: number): ILayerRuntimeStatus => ({
  status: 'unknown',
  lastUpdated: Date.now(),
  cycle
});

export const getLayerKey = (layer?: ILayer): string => {
  if (!layer) {
    return 'unknown-layer';
  }

  return `${layer.name}|${layer.type}|${layer.url || ''}|${layer.layers || ''}`;
};